import React from 'react'
import {Grid, Typography, Button, List} from '@mui/material';
import colors from '../../../../../colors';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { selectVodafoneTopupState, displayMainUtilityView, changeConfirmationDialogState } from '../../../../../../features/vodafone/vodafoneTopupSlice';
import { sendGeneralRequest } from '../../../../../../features/generalRequest';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import SingleInvoice from '../../SingleInvoice';
import ConfirmationDialog from '../../../../../general/ConfirmationDialog'
import { texts } from '../../../../../general/texts';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper
    },
    nested: {
      paddingLeft: theme.spacing(4)
    },
    scrollBar: {
      "&::-webkit-scrollbar": {
        width: "10px",
        height:"50%",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: '#FFFFFF',
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
        borderRadius: "10px",
        maxHeight:'50%'
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
      },
        maxHeight:'53vh',
        overflow:'auto',
        paddingLeft:'6%',
        marginTop:'1%',
        '@media (max-width: 899px )' : {height:'80%'}
    }
  }));

export const VodafoneInvoiceList = (props) => {

    const dispatch = useDispatch()
    const vodafoneSliceState = useSelector(selectVodafoneTopupState)
    const classes = useStyles();
    const [selectedInvoice, setSelectedInvoice] = React.useState({})

    const handleConfirmation = () => {
        dispatch(
          sendGeneralRequest({
            request: {
              _request: {
                token: props.globalDataSliceState.token,
                transID: vodafoneSliceState.transactionId,
                productValue: parseFloat(
                  selectedInvoice.Vlera.replace(/[^.\d]/g, "")
                ),
                productID: selectedInvoice.Id,
                subscriberBalance: parseFloat(
                  vodafoneSliceState.subscriberBalance
                ),
                Name: selectedInvoice.Emri,
                bundleDiscount: selectedInvoice.Ulje.replace(/[^.\d]/g, ""),
              },
            },
            baseUrlKey: "services",
            endpoint: "ASBS/ConfirmVodafoneOffer",
          })
        );
        dispatch(changeConfirmationDialogState()) 
    }

    const handleInvoiceClick = (invoice) => 
    {
      setSelectedInvoice(invoice)
      dispatch(changeConfirmationDialogState())
    }
    

  return (
    <Grid container p={2.4}>
            <Grid container pt={3} pb={2}>
                <Grid container item md={1.5} xs={3} justifyContent={'left'} alignContent={'center'}  ><Button onClick={()=> {dispatch(displayMainUtilityView())}} sx={{height:'4rem', borderRadius:'100%',":hover":{background:colors.white}}} ><ArrowBackIosNewIcon color='warning' /></Button></Grid>
                <Grid container item md={10} xs={8} justifyContent={'left'} alignContent={'center'}  ><Typography sx={{fontWeight:'bold', color:colors.darkBlue}} variant='h5'>{texts["title-obligations-list"]}</Typography></Grid>
            </Grid>
            <Grid item md={12}  className={classes.scrollBar} maxHeight= {'53vh'} overflow= {'auto'}>
                <List className={classes.root}>     
                    {vodafoneSliceState.invoiceList.length > 0 && vodafoneSliceState.invoiceList.map((invoice, index) => {
                        return <Grid item md={12} key={index}><SingleInvoice utilityInfo={props.utilityInfo} contractData={invoice} isMultiSelect={false} onClick={() => {handleInvoiceClick(invoice)}}/></Grid>
                    })}    
                </List>                          
            </Grid> 
            {props.vodafoneTopupSliceState.isConfirmationDialogOpen && <ConfirmationDialog handleClose={()=>{dispatch(changeConfirmationDialogState())}} isConfirmationDialogOpen={props.vodafoneTopupSliceState.isConfirmationDialogOpen} data={texts["message-confirm-transaction-general"]} handleConfirmationClick={handleConfirmation}/>}   
        </Grid>
  )
}
export default VodafoneInvoiceList